import React, { Component, Fragment } from 'react';
import {
  withComposedEnhancers,
  withCombinedStyles
} from '../../utils/hocUtils';
import { withNamespaces } from 'react-i18next';
import { withApollo } from 'react-apollo';
import _get from 'lodash/get';

import Grid from '@material-ui/core/Grid';
import LoadingIndicator from '../../components/LoadingIndicator';
import ErrorNotification from '../../components/common/ErrorNotification';

import classnames from 'classnames';
import TypographyStyles from '../../styles/typography';
import LayoutStyles from '../../styles/layout';
import SpacingStyles from '../../styles/helpers/spacing';
import ReportStyles from './Report.styles';

import { Paper, Typography } from '@material-ui/core';
import Breadcrumbs from '@material-ui/lab/Breadcrumbs';
import { Link } from 'react-router-dom';
import { Table as DvExTable } from '@devexpress/dx-react-grid-material-ui';

import Table from '../../components/Global/Table/Table';
import { LinkFieldFormatter } from '../../components/Global/Table/DataFormatters';

import tableMetadata from './InvoiceBatchDetailTable.metadata';
// import * as DataAccess from './InvoiceBatchDetail.data.mock';
import * as DataAccess from './InvoiceBatchDetail.data';
import moment from 'moment';

export class InvoiceBatchDetail extends Component {
  state = {
    carrierBatchId: _get(this.props, 'match.params.id', null),
    carrierBatch: null,
    loading: true,
    error: false
  };

  async componentDidMount() {
    await this._loadData();
  }

  _loadData = async () => {
    const { client: ApolloClient } = this.props;
    this.setState({
      loading: true
    });
    try {
      const carrierBatch = await DataAccess.retrieveData(
        this.state.carrierBatchId,
        ApolloClient
      );
      this.setState({
        carrierBatch
      });
    } catch (error) {
      this.setState({
        error: true
      });
    } finally {
      this.setState({
        loading: false
      });
    }
  };

  _handleRowClick = row => {
    this.props.history.push(`/invoices/${row.invoiceId}`);
  };

  _handleShipmentLinkClick = ({ row }) => {
    this.props.history.push(`/shipments/${row.shipmentId}`);
  };

  render() {
    const { classes, t } = this.props;
    const { carrierBatchId, carrierBatch, error, loading } = this.state;
    const tableColumns = tableMetadata.columns(t);

    return (
      <Fragment>
        <div>
          <div className={classes.titleRootWrapper}>
            <Breadcrumbs
              separator="›"
              arial-label="Breadcrumb"
              className={classnames(classes.headline5)}
            >
              <Link className={classnames(classes.headline4)} to="/reports">
                {t('Reports')}
              </Link>
              <Link to="/reports/carrier-invoice-batches">
                {t('Invoice Batches')}
              </Link>
              <span>
                {t('Batch #')}
                {carrierBatchId}
                {carrierBatch &&
                  ` (${carrierBatch.carrierScac || carrierBatch.carrierName})`}
              </span>
            </Breadcrumbs>
          </div>
        </div>
        {error && <ErrorNotification message="Error loading page" />}
        {loading && <LoadingIndicator />}
        {carrierBatch && (
          <Fragment>
            <Paper
              square
              className={classnames(
                classes.marginBottom3,
                classes.containerPadding2
              )}
            >
              <Grid container spacing={24}>
                <Grid item xs={2}>
                  <Typography className={classes.summaryTotal}>
                    ${carrierBatch.totalAmountDue}
                  </Typography>
                </Grid>
                <Grid item xs={10}>
                  <Typography
                    className={classnames(
                      classes.headline6,
                      classes.marginBottom1
                    )}
                  >
                    {carrierBatch.carrierName}
                  </Typography>
                  <Typography className={classes.body1light}>
                    {t('Processed on')}{' '}
                    {moment(carrierBatch.createdLocal).format(
                      'MMM D, YYYY hh:mm a'
                    )}
                  </Typography>
                </Grid>
              </Grid>
            </Paper>

            <Table
              name={t('Invoices')}
              columns={tableColumns}
              data={carrierBatch.carrierItems}
              orderBy="dueDate"
              order={'desc'}
              rowComponent={props => (
                <DvExTable.Row
                  {...props}
                  className={classes.tableRow}
                  onClick={() => this._handleRowClick(props.row)}
                />
              )}
              totalCount={carrierBatch.invoiceCount}
              loading={this.state.loading}
              withDownload={false}
              withColumnChooser={false}
              withSelection={false}
              withPagination={false}
              dateColumns={tableMetadata.dateColumns}
              currencyColumns={tableMetadata.currencyColumns}
              valueIfBlank="--"
            >
              <LinkFieldFormatter
                onClick={this._handleShipmentLinkClick}
                for={['shipmentId']}
              />
            </Table>
          </Fragment>
        )}
      </Fragment>
    );
  }
}

const localStyles = theme => ({
  summaryTotal: {
    fontFamily: theme.typography.font.second,
    fontSize: '34.54px',
    fontWeight: 400,
    letterSpacing: '0.25px',
    lineHeight: '41px'
  }
});

export default withComposedEnhancers(
  InvoiceBatchDetail,
  withNamespaces(),
  withCombinedStyles(
    true,
    TypographyStyles,
    SpacingStyles,
    LayoutStyles,
    ReportStyles,
    localStyles
  ),
  withApollo
);
